import { Injectable } from '@angular/core';

@Injectable()
export class SharedStore {
	public title: string;
	public page: string;
}



// WEBPACK FOOTER //
// ./src/app/core/providers/shared.ts